import yup from "../../../../../../utils/yup-extended";

const isFileOrUrl = (value: FileFieldValue) => {
  if (!value) return false;
  if (typeof value === "string") return true; // backend image URL
  if (value instanceof File) return true;
  return false;
};

export const createKycDocumentUploadStepFormValidationSchema = yup.object().shape({
  proofOfAddress: yup
    .mixed()
    .test("file-required", "Proof of address is required", isFileOrUrl),

  governmentId: yup
    .mixed()
    .test("file-required", "Government ID is required", isFileOrUrl),

  selfieWithId: yup
    .mixed()
    .test("file-required", "Selfie with ID is required", isFileOrUrl),

  businessRegistration: yup
    .mixed()
    .test("file-type", "Invalid file type", (value: FileFieldValue) => {
      if (!value) return true;
      if (typeof value === "string") return true;
      return value instanceof File && value.type.startsWith("image/");
    }),
  confirmAccuracy: yup
    .boolean()
    .oneOf([true], "You must confirm the information is accurate."),
});

export type CreateKycDocumentUploadStepDocumentField =
  | "proofOfAddress"
  | "governmentId"
  | "selfieWithId"
  | "businessRegistration";

export type FileFieldValue = File | string | null;

export type CreateKycDocumentUploadStepFormValues = Record<
  CreateKycDocumentUploadStepDocumentField,
  FileFieldValue
> & {
  confirmAccuracy: boolean;
};
